// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'name' implicitly has an 'any' type.
const getSliderAriaLabelArray = (name) => {
  return [`${name} range minimum value`, `${name} range maximum value`];
};

export { getSliderAriaLabelArray };
